import api from './api';
import { ExpenseCreate, ExpenseUpdate, ExpenseFilter, ExpenseResponse } from '../types/expense';
import { generateTempId, getNextSheetRow } from '../utils/expenseUtils';

class ExpenseService {
  // Получение списка расходов с фильтрацией
  // Бэкенд автоматически фильтрует по сегодняшней дате
  async getExpenses(filters: ExpenseFilter = {}): Promise<ExpenseResponse> {
    const params = new URLSearchParams();
    if (filters.restaurant_id) params.append('restaurant_id', filters.restaurant_id);
    if (filters.article) params.append('article', filters.article);
    if (filters.amount_min) params.append('amount_min', filters.amount_min.toString());
    if (filters.amount_max) params.append('amount_max', filters.amount_max.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.sort_by) params.append('sort_by', filters.sort_by);
    if (filters.sort_order) params.append('sort_order', filters.sort_order);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());

    return await api.get(`/expenses/?${params.toString()}`);
  }

  // Создание нового расхода
  async createExpense(data: ExpenseCreate): Promise<{ expense_id: string; status: string }> {
    // Добавляем временный ID и номер строки для Google Sheets
    const expenseData = {
      ...data,
      temp_id: data.temp_id || generateTempId(),
      sheet_row: data.sheet_row || getNextSheetRow([])
    };
    
    return await api.post('/expenses/', expenseData);
  }

  // Синхронизация с Google Sheets
  async syncWithGoogleSheets(expenseId: string): Promise<any> {
    return await api.post(`/expenses/${expenseId}/sync`, {});
  }

  // Массовая синхронизация с Google Sheets
  async bulkSyncWithGoogleSheets(expenseIds: string[]): Promise<any> {
    return await api.post('/expenses/bulk-sync', { expense_ids: expenseIds });
  }

  // Обновление расхода
  async updateExpense(id: string, data: ExpenseUpdate): Promise<{ expense_id: string; status: string }> {
    return await api.put(`/expenses/${id}`, data);
  }

}

export default new ExpenseService();
